import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPagesList } from './components/LandingPagesList';
import { LandingPageForm } from './components/LandingPageForm';
import SingleLandingPage from './single';

const LandingPagesRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<LandingPagesList />} />
      <Route path='create' element={<LandingPageForm />} />
      <Route path='edit/:id' element={<LandingPageForm />} />
      <Route path=':id' element={<SingleLandingPage />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default LandingPagesRoutes;

